<div *ngIf="display">

<div class="text-center" style="padding-top: 10px">
    <h1>Backseat Trader Newsletter Upload</h1>
</div>

<div class="styling">
    <div class="text-center">
        <div>

            <form id="signup">
                <div class="formBox">
                    <!-- <input id="fname" class="form-control" name="fname" id="subscribeEmail" type="text" placeholder="Type your email.."> -->
                    <table style="margin: auto;">
                        <tr>
                            <td><input id="title" class="form-control" name="title" type="text"
                                    placeholder="Type your title.." (input)="newsletterTitle=$event.target.value"></td>
                        </tr>
                        <tr>
                            <td>
                                <textarea id="body" name="body" rows="4" cols="50" placeholder="Type the body here..."
                                    (input)="newsletterBody=$event.target.value">

                            </textarea>
                            </td>
                        </tr>
                    </table>

                </div>
            </form>
            <div id="message"></div>

        </div>
        <input class="form-control" type="file" (change)="onChange($event)">
        <br /><br />
        <button (click)="onUpload()" class="btn theme-btn hoverclr animate">
            Upload
        </button>

    </div>
    <br />
    <!-- Shareable short link of  uoloaded file -->
    <div class="container text-center jumbotron" *ngIf="shortLink">
        <h2> Visit Here</h2>
        <a href="{{shortLink}}">{{shortLink}}</a>
    </div>

    <!--Flag variable is used here-->
    <div class="container" *ngIf="loading">
        <h3>Loading ...</h3>
    </div>
</div>
</div>

<div *ngIf != "display">
    Content is prohibited
</div>